import MainPage from './pages/MainPage.vue';
export default {
  name: 'App',
  components: {
    MainPage
  }
};